exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4956db02] .el-card__body{height:100%}[data-v-4956db02] .el-icon-arrow-right{display:none}", ""]);

// exports
